/* eslint-disable consistent-return, no-param-reassign, no-underscore-dangle */

'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _ = require('lodash');
var moment = require('moment-timezone');
var _require = require('number-to-words'),
  toWords = _require.toWords;
var mathjs = require('mathjs');
var formatHelper = require('@knack/format-helper');
var math = mathjs.create(mathjs.all);
var InvalidEquationError = require('./invalid-equation-error');
var utils = require('./utils');
var backSlashRegex = /\\/g;
var escapedBackslashRegex = /\\\\/g;
var newLineRegex = /\n/g;
var tabRegex = /\t/g;
var percentRegex = /%/g;
var encodedPercentRegex = /&#37;/g;
var invalidTernaryRegEx = /\?\s*:/;
var openParenReqex = /\(/g;
var encodedOpenParenRegex = /&#40;/g;
var closeParenReqex = /\)/g;
var encodedCloseParenRegex = /&#41;/g;
var doubleQuoteRegex = /"/g;
var alphaNumericAndHyphenRegex = /[^0-9.-]+/g;
var groupingSymbolsRegex = /[^0-9A-Za-z{}:".-]+/g;
var literalDateRegex = /\d{2}\/\d{2}\/\d{4}/;
var whitespaceOnlyRegex = /^\s+$/;
var FIELD_PLACEHOLDER = '{field_%}';
// matches all {field_x} or connection field {field_x.field_y}
var fieldReplacementRegex = /{(field_[a-z\d]+\.)?field_[a-z\d]+}/g;
var allowedChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.split('');
var statesArray = ['AK', 'AL', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
var personTitlePrefix = ['Ms.', 'Mrs.', 'Mr.', 'Dr.'];

// We have unused functions that are used by the eval input.
// To avoid minifiers and bundlers in other repos that consume this library to remove the dead code
// and break functionality we assign these unused functions to a global variable, so these never get removed.
// The global will be window if we are in browsers and global if we are in node.
var globalVariable = typeof window !== 'undefined' ? window : global;
globalVariable.equationHelperEvalFunctions = {};

// MathJS nodes that we don't allow. See also: https://mathjs.org/docs/expressions/expression_trees.html#nodes
var disallowedMathJsNodeTypes = new Set([
// function assignment is like: `f(x) = x^2`. if we allow this, customers could make recursive functions
// that crash node
'FunctionAssignmentNode',
// object node is a JSON-object such as: `{hello: 17}`. these should not make it this far anyway
// because `{field_x}` is used for variable replacement, and any remaining `{....}` code is replaced
// before we pass the value into equation helper.
'ObjectNode',
// a range is like `100:200`, shorthand for a matrix (array) of all numbers between 100 and 200. these
// have caused out-of-memory errors in the past, mainly due to users inadvertently using one when they
// meant to use ternary operator.
'RangeNode']);

// MathJS functions that we don't allow. See also: https://mathjs.org/docs/reference/functions.html
var disallowedMathJsFunctionNames = new Set([
// `range(a,b)` is equivalent to `a:b` which is not allowed per above
'range',
// these three functions create matrices of a given size, and if that size is too large it
// causes out-of-memory errors.
'identity', 'ones', 'zeros']);

// Older versions of mathjs would support var().
// After https://github.com/josdejong/mathjs/blob/develop/HISTORY.md#2019-06-08-version-600 update, variance is the
// only way of calling this function. To allow for backward-compatibility we will add a new function `var` that
// redirects the arguments to mathjs.variance() function.
function mathVarPolyfill() {
  return math.variance.apply(math, arguments);
}
math["import"]({
  "var": mathVarPolyfill
});
var debugging = false;
var delog = debugging ? function (msg, meta) {
  return console.log(msg, meta);
} : function () {}; // eslint-disable-line no-console

var commonEquationHelper = {
  convertDateVal: function convertDateVal(val, dateType) {
    if (!val) {
      return 0;
    }
    switch (dateType) {
      case 'hours':
        return val * 60 * 60;
      case 'weeks':
        return val * 7 * 24 * 60 * 60;
      case 'years':
        return "{\"years\": ".concat(val, "}");
      case 'days':
      default:
        return val * 24 * 60 * 60;
    }
  },
  translateDateVal: function translateDateVal(val, inputDateType, outputDateType) {
    if (debugging) {
      global.log("translate ".concat(val, " from ").concat(inputDateType, " to ").concat(outputDateType));
    }
    val *= 1000;
    if (!val) {
      return 0;
    }
    switch (inputDateType) {
      case 'hours':
        val = val * 60 * 60;
        break;
      case 'weeks':
        val = val * 7 * 24 * 60 * 60;
        break;
      case 'years':
        val = val * 365.25 * 24 * 60 * 60;
        break;
      case 'days':
      default:
        val = val * 24 * 60 * 60;
        break;
    }
    if (debugging) {
      global.log('date in standard format is:');
      global.log(moment(new Date(val)).format());
    }
    switch (outputDateType) {
      case 'hours':
        val = val / 60 / 60;
        break;
      case 'weeks':
        val = val / 7 / 24 / 60 / 60;
        break;
      case 'years':
        val = val / 365.25 / 24 / 60 / 60;
        break;
      case 'days':
      default:
        val = val / 24 / 60 / 60;
        break;
    }
    val /= 1000;
    if (debugging) {
      global.log('translation output is');
      global.log(val);
      global.log(moment(new Date(val)).format());
    }
    return val;
  },
  convertEquationTime: function convertEquationTime(calc, dateType, client) {
    var _calc$match;
    var _this = this;

    // since we don't have the luxury of tracking each numeric item in the equations separately
    // like we did in previous equations, we need to find and parse date equation formatting per
    // number manually by iterating the string and finding numbers

    // used for tracking current position in the calc string
    var position = 0;

    // used for tracking the replacement indexes for numbers as they are found
    var numberStartPosition = 0;
    var numberEndPosition = 0;
    var onNumber = false;

    // used to prevent numbers in field_xx strings from being picked up
    var ignoreNextNumber = false;

    // string to store current number to be converted
    var currentNumber = '';

    // list of replacements that we need to make after we've found and formatted all of the numbers within the calc
    var replacements = [];

    // for alphanumeric fields like field_ab12d, ignoreNextNumber gets flipped and a replacement is done
    // mid-string resulting in something like field_ab89600d. Easy work around is to find all field_xx and
    // replace with a placeholder then repopulate at the end.
    var fieldReplacements = _toConsumableArray((_calc$match = calc.match(fieldReplacementRegex)) !== null && _calc$match !== void 0 ? _calc$match : []);
    if (fieldReplacements.length > 0) {
      calc = calc.replaceAll(fieldReplacementRegex, FIELD_PLACEHOLDER);
    }

    // iterate the calc string, find and convert numbers
    _.each(calc.split(''), function (calcChar) {
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(calcChar) && !ignoreNextNumber && calcChar !== ' ' || onNumber && calcChar === '.') {
        if (!onNumber) {
          // if the previous char wasn't a number, we are tracking a new number
          numberStartPosition = position;
          numberEndPosition = position + 1;
          onNumber = true;
          currentNumber += calcChar;
        } else {
          // continue tracking an existing number
          numberEndPosition = position + 1;
          currentNumber += calcChar;
        }
      } else if (onNumber) {
        // no longer on a number
        onNumber = false;
        currentNumber = _this.convertDateVal(client ? Number(currentNumber) * 1000 : Number(currentNumber), dateType);
        replacements.push({
          value: currentNumber,
          start_position: numberStartPosition,
          end_position: numberEndPosition
        });
        currentNumber = '';
      } else if (calcChar === '_') {
        // if we see a _ it's probably from {field_xx} which means we don't want to try to replace the following number
        ignoreNextNumber = true;
        // eslint-disable-next-line no-restricted-globals
      } else if (ignoreNextNumber && isNaN(calcChar)) {
        // switch off ignore_next_number
        ignoreNextNumber = false;
      }
      position += 1;
    });

    // take care of any open numbers:
    if (onNumber) {
      onNumber = false;
      currentNumber = _this.convertDateVal(client ? Number(currentNumber) * 1000 : Number(currentNumber), dateType);
      replacements.push({
        value: currentNumber,
        start_position: numberStartPosition,
        end_position: numberEndPosition
      });
    }

    // reverse the replacements so we do it starting from the end and working towards the beginning.
    // makes it so we don't need to track length of inserted strings
    replacements = replacements.reverse();

    // replace the numbers
    _.each(replacements, function (replacement) {
      if (!replacement || !replacement.value) {
        return;
      }

      // insert the formatted number
      calc = calc.slice(0, replacement.start_position) + replacement.value.toString() + calc.slice(replacement.end_position);
    });

    // replace all the placeholders with their corresponding fields keys
    var _iterator = _createForOfIteratorHelper(fieldReplacements),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var fieldReplacement = _step.value;
        calc = calc.replace(FIELD_PLACEHOLDER, fieldReplacement);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return calc;
  },
  parseUnitOf: function parseUnitOf(dateString, unitIn, unitOf, timezone) {
    if (debugging) {
      global.log('parseUnitOf()');
      global.log(dateString);
      global.log(unitIn);
      global.log(unitOf);
      global.log(timezone);
    }
    var date;
    if (!dateString || dateString === '') {
      return 0;
    }

    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(Number(dateString))) {
      date = moment.tz(parseInt(dateString, 10), timezone);
      var offset = date._offset;
      date.subtract(offset, 'minutes');
      dateString = Number(dateString);
    } else {
      date = moment.tz(dateString, timezone);
    }

    // eslint-disable-next-line eqeqeq
    if (date._d == 'Invalid Date') {
      // at this point, date_string is in UTC (example: 2015-01-01T00:00:00+00:00)
      // date will be in the app's timezone, meaning the original date, plus the
      // tz offset (example: 2014-12-31T19:00:00-05:00)
      date = moment.tz(parseInt(dateString, 10), timezone);

      // adjust back to the original date_string time, but in the app's own
      // timezone (example: 2015-01-01T00:00:00-05:00)
      var _offset = date._offset;
      date.subtract(_offset, 'minutes');
    } else if ((String(dateString).indexOf('/') > -1 || String(dateString).indexOf(',') > -1) && String(dateString).indexOf(':') === -1) {
      // a date with no time was passed, we need to adjust it by the timezone to avoid being calculated as the wrong day
      var _offset2 = moment.tz(dateString, timezone)._offset;
      date.subtract(_offset2, 'minutes');
    }
    switch (unitOf) {
      case 'week':
        switch (unitIn) {
          case 'day':
            // dayOfWeek(date)
            return date.day() + 1;
          default:
            delog("invalid unitIn: ".concat(unitIn));
            break;
        }
        break;
      case 'month':
        switch (unitIn) {
          case 'day':
            // dayOfMonth(date)
            return date.date();
          default:
            delog("invalid unitIn: ".concat(unitIn));
            break;
        }
        break;
      case 'quarter':
        return date.quarter();
      // getDateQuarter
      case 'year':
        switch (unitIn) {
          case 'day':
            // dayOfYear(date)
            return date.dayOfYear();
          case 'week':
            // weekOfYear(date)
            return date.week();
          case 'month':
            // monthOfYear(date)
            return date.month() + 1;
          // moment 0 indexes months for some reason
          case 'year':
            return date.year();
          default:
            delog("invalid unitIn: ".concat(unitIn));
            break;
        }
        break;
      default:
        delog("invalid unitOf: ".concat(unitOf));
        break;
    }
  },
  evalStringEquation: function evalStringEquation(equation, outputString, testEquation, timezone, dateEquation) {
    var _this = this;
    delog("evaluating equation: ".concat(equation));
    delog(dateEquation);
    equation = equation.replace(backSlashRegex, '\\\\');
    var numericSupportedFunctions = ['left', 'right', 'mid', 'length', 'replace', 'regexReplace', 'extractRegex', 'lower', 'upper', 'capitalize', 'trim', 'trimLeft', 'trimRight', 'getDateDayOfWeek', 'getDateDayOfMonth', 'getDateYear', 'getDateWeek', 'getDateMonth', 'getDateDayOfWeekName', 'getDateMonthOfYearName', 'convertTimezone', 'formatDate', 'getAddressStreet', 'getAddressStreet2', 'getAddressCity', 'getAddressZip', 'getNameTitle', 'getNameFirst', 'getNameMiddle', 'getNameLast', 'getLinkURL', 'getLinkLabel', 'getDateQuarter', 'getAddressCountry', 'getAddressState', 'getDateLastDateOfMonth', 'netWorkDays'];
    var dateSupportedFunctions = [].concat(numericSupportedFunctions, ['min', 'max']);
    var stringSupportedFunctions = ['left', 'right', 'mid', 'length', 'replace', 'regexReplace', 'extractRegex', 'lower', 'upper', 'capitalize', 'trim', 'trimLeft', 'trimRight', 'random', 'getDateDayOfWeek', 'getDateDayOfMonth', 'getDateYear', 'getDateWeek', 'getDateMonth', 'getDateDayOfWeekName', 'getDateMonthOfYearName', 'convertTimezone', 'formatDate', 'getAddressStreet', 'getAddressStreet2', 'getAddressCity', 'getAddressZip', 'getNameTitle', 'getNameFirst', 'getNameMiddle', 'getNameLast', 'getLinkURL', 'getLinkLabel', 'getDateQuarter', 'getAddressCountry', 'getAddressState', 'min', 'max', 'getDateLastDateOfMonth', 'numberToWords', 'netWorkDays'];

    // eslint-disable-next-line max-len, no-nested-ternary
    var supportedFunctions = outputString ? stringSupportedFunctions : dateEquation ? dateSupportedFunctions : numericSupportedFunctions;
    var parseJSON = function parseJSON(string) {
      string = decodeURIComponent(string);
      string = string.replace(newLineRegex, '\\n').replace(tabRegex, '\\t');
      try {
        return JSON.parse(string);
      } catch (error) {
        // this is used by currentTime() as well as the equation-editor
        if (moment.isDate(moment(string).toDate())) {
          return string;
        }
        return {};
      }
    };
    var decodeHtmlCharCodes = function decodeHtmlCharCodes(string) {
      return string.replace(/(&#(\d+);)/g, function (match, capture, charCode) {
        return String.fromCharCode(charCode);
      });
    };
    var sanitizeString = function sanitizeString(string) {
      return String(string).replace(percentRegex, '&#37;').replace(backSlashRegex, '\\\\').replace(openParenReqex, '&#40;').replace(closeParenReqex, '&#41;');
    };
    var deSanitizeString = function deSanitizeString(string) {
      return String(string).replace(encodedPercentRegex, '%').replace(escapedBackslashRegex, '\\').replace(encodedOpenParenRegex, '(').replace(encodedCloseParenRegex, ')');
    };
    var _stripYearObjects = function stripYearObjects(string) {
      var yearToken = '{"years":';
      var yearObjectIndex = string.indexOf(yearToken);
      var closeObjectIndex = string.indexOf('}');
      if (yearObjectIndex === -1 || closeObjectIndex === -1) {
        if (debugging) {
          global.log('no years to strip, return');
        }
        return string;
      }
      var yearValue = string.slice(yearObjectIndex + yearToken.length, closeObjectIndex);
      var yearValueMs = Number(yearValue) * 365.25 * 24 * 60 * 60;
      string = string.slice(0, yearObjectIndex) + yearValueMs + string.slice(closeObjectIndex + 1, string.length);
      return _stripYearObjects(string);
    };
    var stripNumericQuotes = function stripNumericQuotes(string) {
      if (!outputString) {
        string = String(string).replace(doubleQuoteRegex, '');
      }
      return string;
    };

    // this function handles allowing moment to handle date addition/subtraction, whereas mathjs doesn't do a
    // very good job with this and often results in leap years causing dates to be off
    var _handleYearDateArithmetic = function handleYearDateArithmetic(string) {
      if (debugging) {
        global.log('handleYearDateArithmetic');
        global.log(string);
      }

      // don't do anything for string output
      if (outputString) {
        if (debugging) {
          global.log('string output, return');
        }
        return string;
      }

      // don't do anything if we don't need to add or subtract any dates
      if (string.indexOf('-') === -1 && string.indexOf('+') === -1) {
        if (debugging) {
          global.log('no arithmetic, return');
        }
        return string;
      }

      // don't do anything if we don't have any years to add
      if (string.indexOf('"years":') === -1) {
        if (debugging) {
          global.log('no years to add/subtract, return');
        }
        return string;
      }
      var _getFirstStandaloneColonInString = function getFirstStandaloneColonInString(searchString) {
        if (!searchString) {
          return -1;
        }
        var position = searchString.indexOf(':');
        var nextPosition = 0;

        // need to find first set of closing parens at this level
        // for example: mid({field}, 1, length({field}) - 2)
        // we want:        ^  and                          ^
        // in:          left({field}, 1) right({field}, 1)
        // we want:         ^          ^
        var openParen = searchString.indexOf('(');
        var closeParen = 0;
        var level = 0;
        var found = false;
        _.each(searchString.split(''), function (stringChar) {
          if (stringChar === '(') {
            level += 1;
          } else if (stringChar === ')') {
            level -= 1;
            if (!found && level === 0) {
              found = true;
            }
          }
          if (!found) {
            closeParen += 1;
          }
        });

        // if we've got an open and close paren, that means that we need to look for a colon after the close, otherwise
        // we might be grabbing a ternary colon inside of the parens (which is not the ternary we are working on now)
        if (openParen > 0 && closeParen > 0) {
          position = closeParen + _getFirstStandaloneColonInString(searchString.substring(closeParen));
        }

        // move to the next position if the previous char was a ", which means we are on a year
        // object (structure is "years":)
        if (searchString[position - 1] === '"') {
          nextPosition = _getFirstStandaloneColonInString(searchString.substring(position + 1));
          if (nextPosition > 0) {
            position += nextPosition + 1;
          }
        }
        return position;
      };
      var attemptParseYearJson = function attemptParseYearJson(jsonString) {
        jsonString = jsonString.trim();
        if (jsonString[0] !== '{') {
          return false;
        }
        if (jsonString[jsonString.length - 1] !== '}') {
          return false;
        }
        return JSON.parse(jsonString).years;
      };

      // detect ternaries. try to evaluate inner year arithmetic so that we can pass only numeric values to mathjs later
      if (string.indexOf('?') > -1 && string.indexOf(':') > -1 && string.lastIndexOf(':') !== string.indexOf(':')) {
        // get the first part of the ternary. everything between the ? and the first : not a part of a year object
        var ternaryCaseOneStartIndex = string.indexOf('?') + 1;
        var ternaryCaseOneStopIndex;
        var ternaryFirstColonIndex = _getFirstStandaloneColonInString(string) - 1;
        var ternaryLastColonIndex = string.lastIndexOf(':') - 1;

        // get the string between the ? and first :. this might result in a string like '1 + {"years"',
        // which is wrong and can mean we used the wrong index
        var ternaryCaseOneString = string.substring(ternaryCaseOneStartIndex, ternaryFirstColonIndex);
        ternaryCaseOneStopIndex = ternaryFirstColonIndex;

        // check for case on strings ending in "years" and try to get with the last index instead
        // this can also be wrong like this: '1 + {"years": 2} : 2 + {"years"', which means that
        // the real index that we wanted is between the 2 original indices
        if (ternaryCaseOneString.endsWith('"years')) {
          ternaryCaseOneString = string.substring(ternaryCaseOneStartIndex, ternaryLastColonIndex);
          ternaryCaseOneStopIndex = ternaryLastColonIndex;
        }

        // check for case of a middle :, with equations that look like this: '1 + {"years": 2} : 3 + {"years": 4}'
        if (ternaryCaseOneString.endsWith('"years')) {
          ternaryFirstColonIndex = string.substring(0, ternaryLastColonIndex).lastIndexOf(':') - 1; // colon between ? and last :
          ternaryCaseOneString = string.substring(ternaryCaseOneStartIndex, ternaryFirstColonIndex);
          ternaryCaseOneStopIndex = ternaryFirstColonIndex;
        }
        var ternaryCaseTwoString = string.substring(ternaryCaseOneStopIndex + 3, string.length);
        var caseTwoValue;
        if (ternaryCaseTwoString.indexOf('"years') > -1) {
          caseTwoValue = _handleYearDateArithmetic(ternaryCaseTwoString);
        } else {
          caseTwoValue = ternaryCaseTwoString;
        }
        var partOne = string.substring(0, ternaryCaseOneStopIndex + 3);
        string = partOne + caseTwoValue;
        var caseOneValue;
        if (ternaryCaseOneString.indexOf('"years') > -1) {
          caseOneValue = _handleYearDateArithmetic(ternaryCaseOneString);
        } else {
          caseOneValue = ternaryCaseOneString;
          ternaryCaseOneStartIndex -= 1;
        }
        partOne = string.substring(0, ternaryCaseOneStartIndex + 1);
        var partTwo = string.substring(ternaryCaseOneStopIndex, string.length);
        string = partOne + caseOneValue + partTwo;
      }

      // check for years again. we may have processed them out while looking for ternary operators
      if (string.indexOf('"years":') === -1) {
        if (debugging) {
          global.log('no years to add/subtract after ternary, return');
          global.log(string);
        }
        return string;
      }
      var currentNumber = '';
      var lastSign = '';
      var lastNumber = '';
      var firstMomentValue = false;
      var parseMomentValue = function parseMomentValue(strippedNumber) {
        var momentValue = moment(Number(strippedNumber) * 1000);
        if (!firstMomentValue) {
          momentValue = moment.tz(Number(strippedNumber) * 1000, timezone);
          firstMomentValue = moment.tz(Number(strippedNumber) * 1000, timezone);
        }
        return momentValue;
      };
      var doArithmetic = function doArithmetic() {
        if (lastNumber.trim() === '') {
          return lastSign + currentNumber;
        }

        // if we have both items as year objects, then we need to parse both of them as a single year object and return
        if (currentNumber.indexOf('"years":') > -1 && lastNumber.indexOf('"years":') > -1) {
          return JSON.stringify({
            years: Number(attemptParseYearJson(currentNumber)) + Number(attemptParseYearJson(lastNumber))
          });
        }

        // we know we are going to do a calculation at this point, remove grouping symbols, etc.
        var strippedLastNumber = lastNumber.replace(groupingSymbolsRegex, '');
        var strippedCurrentNumber = currentNumber.replace(groupingSymbolsRegex, '');
        var parsedLastNumber = attemptParseYearJson(strippedLastNumber);
        var parsedCurrentNumber = attemptParseYearJson(strippedCurrentNumber);
        if (!parsedCurrentNumber && !parsedLastNumber) {
          return lastNumber + lastSign + currentNumber;
        }

        // handle the case when the last number is the valid date
        if (currentNumber.indexOf('"years":') > -1) {
          if (lastSign === '-') {
            return String(Number(parseMomentValue(strippedLastNumber).subtract(parsedCurrentNumber, 'years')._d) / 1000);
          }
          return String(Number(parseMomentValue(strippedLastNumber).add(parsedCurrentNumber, 'years')._d) / 1000);
        }

        // handle the case when the first number is the valid date
        if (lastNumber.indexOf('"years":') > -1) {
          if (lastSign === '-') {
            return String(Number(parseMomentValue(strippedCurrentNumber).subtract(parsedLastNumber, 'years')._d) / 1000);
          }
          return String(Number(parseMomentValue(strippedCurrentNumber).add(parsedLastNumber, 'years')._d) / 1000);
        }
        if (lastSign === '+') {
          return String(Number(strippedLastNumber) + Number(strippedCurrentNumber));
        }
        return String(Number(strippedLastNumber) - Number(strippedCurrentNumber));
      };
      _.each(string.split(''), function (character) {
        if (character === '-' || character === '+') {
          if (lastSign !== '') {
            currentNumber = doArithmetic();
          }
          lastNumber = currentNumber;
          currentNumber = '';
          lastSign = character;
          return;
        }
        currentNumber += character;
      });
      var arithmeticOutput = doArithmetic();
      var arithmeticOutputNumber = Number(arithmeticOutput * 1000);
      var dateOutput;

      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(arithmeticOutputNumber)) {
        var tzOffset = firstMomentValue ? firstMomentValue._offset : 0;

        // parse out the date adjusted to the current timezone, otherwise the date can be off when
        // leap year adjustments happen
        dateOutput = String(Number(moment(arithmeticOutputNumber).subtract(tzOffset, 'minutes')._d / 1000));
      } else {
        dateOutput = arithmeticOutput;
      }
      return dateOutput;
    };
    var isDate = function isDate(string) {
      // eslint-disable-next-line no-restricted-globals
      if (string && isNaN(string) && string.trim() === '0') {
        return false;
      }
      try {
        return moment.isDate(moment(string).toDate());
      } catch (error) {
        return false;
      }
    };
    var numberToWords = function numberToWords(string) {
      if (!string) {
        return '';
      }
      var inputObject = parseJSON(string);
      string = inputObject && inputObject.formatted_value ? String(inputObject.formatted_value) : String(string);
      string = string.replace(alphaNumericAndHyphenRegex, '');
      var stringDecimals = '';
      if (string.indexOf('.') > -1) {
        var decimals = string.substring(string.indexOf('.') + 1, string.length);
        stringDecimals = " point ".concat(toWords(decimals));
      }
      return toWords(string) + stringDecimals;
    };
    var getDateDayOfWeekName = function getDateDayOfWeekName(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.raw_value || inputObject.formatted_value : string;
      if (!string || !isDate(string.raw_value || string)) {
        return outputString ? '' : 0;
      }
      string = _this.parseUnitOf(string.raw_value || string, 'day', 'week', timezone);
      if (outputString) {
        switch (string) {
          case 1:
            string = 'Sunday';
            break;
          case 2:
            string = 'Monday';
            break;
          case 3:
            string = 'Tuesday';
            break;
          case 4:
            string = 'Wednesday';
            break;
          case 5:
            string = 'Thursday';
            break;
          case 6:
            string = 'Friday';
            break;
          case 7:
            string = 'Saturday';
            break;
          default:
            delog("Invalid day of week: ".concat(string));
            break;
        }
      }
      return string;
    };
    var getDateDayOfWeek = getDateDayOfWeekName;
    var getDateDayOfMonth = function getDateDayOfMonth(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.raw_value || inputObject.formatted_value : string;
      if (!string || !isDate(string.raw_value || string)) {
        return 0;
      }
      string = _this.parseUnitOf(string.raw_value || string, 'day', 'month', timezone);
      return string;
    };
    var getDateLastDateOfMonth = function getDateLastDateOfMonth(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.raw_value || inputObject.formatted_value : string;
      var dateString = string.raw_value || string;
      if (!string || !isDate(dateString)) {
        return 0;
      }

      // Assume that input is already relative to the app's timezone
      var date = moment(Number(dateString) * 1000);
      date = date.endOf('month');

      // Assume consumer will know the result is in the app timezone
      return Number(date._d) / 1000;
    };
    var getDateQuarter = function getDateQuarter(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.raw_value || inputObject.formatted_value : string;
      // eslint-disable-next-line no-restricted-globals
      if (!string || isNaN(string.raw_value || string)) {
        return 0;
      }
      string = _this.parseUnitOf(string.raw_value || string, 'day', 'quarter', timezone);
      return string;
    };
    var getDateWeek = function getDateWeek(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.raw_value || inputObject.formatted_value : string;
      if (!string || !isDate(string.raw_value || string)) {
        return 0;
      }
      string = _this.parseUnitOf(string.raw_value || string, 'week', 'year', timezone);
      return string;
    };
    var getDateMonthOfYearName = function getDateMonthOfYearName(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.raw_value || inputObject.formatted_value : string;
      if (!string || !isDate(string.raw_value || string)) {
        return outputString ? '' : 0;
      }
      string = _this.parseUnitOf(string.raw_value || string, 'month', 'year', timezone);
      if (outputString) {
        switch (string) {
          case 1:
            string = 'January';
            break;
          case 2:
            string = 'February';
            break;
          case 3:
            string = 'March';
            break;
          case 4:
            string = 'April';
            break;
          case 5:
            string = 'May';
            break;
          case 6:
            string = 'June';
            break;
          case 7:
            string = 'July';
            break;
          case 8:
            string = 'August';
            break;
          case 9:
            string = 'September';
            break;
          case 10:
            string = 'October';
            break;
          case 11:
            string = 'November';
            break;
          case 12:
            string = 'December';
            break;
          default:
            delog("invalid month: ".concat(string));
            break;
        }
      }
      return string;
    };
    var getDateMonth = getDateMonthOfYearName;
    var netWorkDays = function netWorkDays(firstDate, secondDate) {
      if (firstDate === secondDate || _.isEmpty(firstDate) || _.isEmpty(secondDate)) {
        return outputString ? '' : 0;
      }
      var firstInput = parseJSON(firstDate);
      if (_.isString(firstInput) && firstInput.match(literalDateRegex)) {
        firstDate = moment(firstInput, 'MM/DD/YYYY').valueOf();
      } else if (firstInput && firstInput.formatted_value) {
        firstDate = firstInput.raw_value || firstInput.formatted_value;
      }
      var secondInput = parseJSON(secondDate);
      if (_.isString(secondInput) && secondInput.match(literalDateRegex)) {
        secondDate = moment(secondInput, 'MM/DD/YYYY').valueOf();
      } else if (secondInput && secondInput.formatted_value) {
        secondDate = secondInput.raw_value || secondInput.formatted_value;
      }
      var firstDateValue = parseFloat(firstDate);
      var secondDateValue = parseFloat(secondDate);
      if (firstDateValue === 0 || secondDateValue === 0) {
        return outputString ? '' : 0;
      }
      var datesChronological = firstDateValue <= secondDateValue;
      if (!datesChronological) {
        var _ref = [secondDateValue, firstDateValue];
        firstDateValue = _ref[0];
        secondDateValue = _ref[1];
      }
      var firstMoment = moment(firstDateValue);
      var secondMoment = moment(secondDateValue);
      var startingDay = firstMoment.day();
      var endingDay = secondMoment.day();
      var sign = datesChronological ? 1 : -1;

      // Following is adapted from https://gist.github.com/jcbagtas/8c622d294fe8ad12bb4af59f8543ce71
      // Add one to days because range is inclusive
      var days = Math.abs(firstMoment.diff(secondMoment, 'days')) + 1;
      // copied verbatim, not sure why moment.diff(weeks) doesn't work
      // eslint-disable-next-line max-len
      var weeks = Math.floor(Math.ceil((secondMoment.toDate().setHours(23, 59, 59, 999) - firstMoment.toDate().setHours(0, 0, 0, 1)) / (86400 * 1000)) / 7);
      var result = days - weeks * 2;
      if (startingDay - endingDay > 1) {
        result -= 2;
      }
      if (startingDay === 0 && endingDay !== 6) {
        result -= 1;
      }
      if (startingDay !== 0 && endingDay === 6) {
        result -= 1;
      }
      return sign * result;
    };
    var convertTimezone = function convertTimezone(string, timezoneOut, format) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.raw_value || inputObject.formatted_value : string;
      timezoneOut = timezoneOut.trim();
      format = format.trim();
      var startTime = moment(string.raw_value || string);
      // eslint-disable-next-line eqeqeq
      if (startTime._d == 'Invalid Date') {
        startTime = moment(parseInt(string, 10));
      }
      var time = moment.tz(startTime, timezoneOut).format(format);
      return time;
    };

    // NOTE: cannot use an arrow function because `arguments` is not defined for arrow function
    // eslint-disable-next-line func-names
    var formatDate = function formatDate(string, format) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.raw_value || inputObject.formatted_value : string;
      if (!format) {
        return '';
      }
      if (!string) {
        return '';
      }
      format = format.trim();
      var startTime = moment(string.raw_value || string);

      // eslint-disable-next-line eqeqeq
      if (startTime._d == 'Invalid Date') {
        startTime = moment(parseInt(string, 10));
      }
      if (arguments.length > 1) {
        for (var i = 2; i < arguments.length; i += 1) {
          format += ",".concat(arguments[i]); // eslint-disable-line prefer-rest-params
        }
      }
      var time = moment(startTime).format(format);
      return time;
    };
    var getDateYear = function getDateYear(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.raw_value || inputObject.formatted_value : string;
      if (!string || !isDate(string.raw_value || string)) {
        return 0;
      }
      string = _this.parseUnitOf(string.raw_value || string, 'year', 'year', timezone);
      return string;
    };
    var left = function left(string, len) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      len = Number(len);
      string = String(string);
      if (len < 0) {
        return '';
      }
      if (len > string.length) {
        return string;
      }
      return string.substring(0, len);
    };
    var right = function right(string, len) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      len = Number(len);
      string = String(string);
      if (len < 1) {
        return '';
      }
      if (len > string.length) {
        return string;
      }
      return string.substring(string.length, string.length - len);
    };
    var mid = function mid(string, start, length) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      start = Number(start);
      length = Number(length);
      string = String(string);
      if (start < 0) {
        start = 0;
      }
      if (start > string.length) {
        return '';
      }
      if (length < 0) {
        return '';
      }
      return string.substring(start, string.length).substring(0, length);
    };
    var length = function length(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return 0;
      }
      string = decodeHtmlCharCodes(String(string));
      return string.length || 0;
    };
    var replace = function replace(string, replaceFind, replaceText) {
      var inputObject = parseJSON(string);
      replaceFind = replaceFind.trim();
      if (replaceFind.indexOf('formatted_value') > -1) {
        replaceFind = parseJSON(replaceFind).formatted_value;
      }
      replaceText = replaceText.trim();
      if (replaceText.indexOf('formatted_value') > -1) {
        replaceText = parseJSON(replaceText).formatted_value;
      }
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      string = String(string);
      var output = string.replace(replaceFind, replaceText);
      return output;
    };
    var regexReplace = function regexReplace(string, regexString, replaceText) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      string = deSanitizeString(string);
      if (replaceText[0] === ' ') {
        replaceText = replaceText.slice(1, replaceText.length);
      }
      if (regexString[0] === ' ') {
        regexString = regexString.slice(1, regexString.length);
      }
      var output = string.replace(new RegExp(regexString, 'g'), replaceText);
      output = sanitizeString(output);
      return output;
    };
    var extractRegex = function extractRegex(string, regexString, regexString2) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      string = deSanitizeString(string);

      // if there is a second regex string input, it was actually the user putting in a regex with a comma
      if (regexString2) {
        regexString += ",".concat(regexString2);
      }
      var output = string.match(new RegExp(regexString.trim()));
      return output && output.length ? sanitizeString(output[0]) : '';
    };
    var lower = function lower(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      string = String(string);
      return string.toLowerCase();
    };
    var upper = function upper(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      string = String(string);
      return string.toUpperCase();
    };
    var trim = function trim(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      string = String(string);
      return string.trim();
    };
    var trimLeft = function trimLeft(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      string = String(string);
      return string.trimLeft();
    };
    var trimRight = function trimRight(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      string = String(string);
      return string.trimRight();
    };
    var capitalize = function capitalize(string) {
      var inputObject = parseJSON(string);
      string = inputObject && typeof inputObject.formatted_value !== 'undefined' ? inputObject.formatted_value : string;
      if (!string) {
        return '';
      }
      string = String(string);
      return string.charAt(0).toUpperCase() + string.slice(1);
    };
    var random = function random(len) {
      // eslint-disable-next-line no-restricted-globals
      if (!len || isNaN(len)) {
        len = 0;
      }
      len = Math.floor(len);
      var string = '';
      _.times(len, function () {
        string += _.shuffle(allowedChars)[0];
      });
      return string;
    };
    var getAddressStreet = function getAddressStreet(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'address') {
        throw new Error('getAddressStreet requires address field.');
      }
      if (testEquation) {
        return "".concat(String(Math.random()).substring(2, 5), " ").concat(string.formatted_value, " ").concat(_.shuffle(['St.', 'Ave.', 'Blvd.', 'Dr.', 'Way', 'Ct.', 'Hwy.'])[0]);
      }
      return string.street || '';
    };
    var getAddressStreet2 = function getAddressStreet2(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'address') {
        throw new Error('getAddressStreet2 requires address field input.');
      }
      if (testEquation) {
        return string.formatted_value;
      }
      return string.street2 || '';
    };
    var getAddressCity = function getAddressCity(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'address') {
        throw new Error('getAddressCity requires address field input.');
      }
      if (testEquation) {
        return string.formatted_value;
      }
      return string.city || '';
    };
    var getAddressState = function getAddressState(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'address') {
        throw new Error('getAddressCity requires address field input.');
      }
      if (testEquation) {
        return _.shuffle(statesArray)[0];
      }
      return string.state || '';
    };
    var getAddressCountry = function getAddressCountry(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'address') {
        throw new Error('getAddressCity requires address field input.');
      }
      if (testEquation) {
        return string.formatted_value;
      }
      return string.country || '';
    };
    var getAddressZip = function getAddressZip(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'address') {
        throw new Error('getAddressZip requires address field input.');
      }
      if (testEquation) {
        return String(Math.random()).substring(2, 7);
      }
      return string.zip || '';
    };
    var getNameTitle = function getNameTitle(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'name') {
        throw new Error('getNameTitle requires name field input.');
      }
      if (testEquation) {
        return _.shuffle(personTitlePrefix)[0];
      }
      return string.title || '';
    };
    var getNameFirst = function getNameFirst(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'name') {
        throw new Error('getNameFirst requires name field input.');
      }
      if (testEquation) {
        return string.formatted_value;
      }
      return string.first || '';
    };
    var getNameMiddle = function getNameMiddle(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'name') {
        throw new Error('getNameMiddle requires name field input.');
      }
      if (testEquation) {
        return string.formatted_value;
      }
      return string.middle || '';
    };
    var getNameLast = function getNameLast(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'name') {
        throw new Error('getNameLast requires name field input.');
      }
      if (testEquation) {
        return string.formatted_value;
      }
      return string.last || '';
    };
    var getLinkURL = function getLinkURL(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'link') {
        throw new Error('getLinkURL requires name field input.');
      }
      if (testEquation) {
        return "http://".concat(string.formatted_value, ".com/");
      }
      return string.url || '';
    };
    var getLinkLabel = function getLinkLabel(string) {
      if (!string) {
        return '';
      }
      string = parseJSON(string);
      if (string && string.field_type && string.field_type !== 'link') {
        throw new Error('getLinkLabel requires name field input.');
      }
      if (testEquation) {
        return string.formatted_value;
      }
      return string.label || '';
    };

    // note that min/max here are sanitization functions mean to remove 0 or blank dates.
    // these are processed by math.js later
    // NOTE: cannot use an arrow function because `arguments` is not defined for arrow function
    // eslint-disable-next-line func-names
    var min = function min() {
      var args = arguments; // eslint-disable-line prefer-rest-params
      if (!args || !args.length) {
        return null;
      }
      if (dateEquation) {
        args = _.reject(args, function (argument) {
          return Number(argument) === 0;
        });
      }
      args = _.map(args, function (argument) {
        return argument;
      });
      return "min&#40;".concat(args.toString(), "&#41;");
    };

    // NOTE: cannot use an arrow function because `arguments` is not defined for arrow function
    // eslint-disable-next-line func-names
    var max = function max() {
      return min.apply(this, arguments).replace('min&', 'max&'); // eslint-disable-line prefer-rest-params
    };
    globalVariable.equationHelperEvalFunctions = {
      numberToWords: numberToWords,
      getDateDayOfWeekName: getDateDayOfWeekName,
      getDateDayOfWeek: getDateDayOfWeek,
      getDateDayOfMonth: getDateDayOfMonth,
      getDateLastDateOfMonth: getDateLastDateOfMonth,
      getDateQuarter: getDateQuarter,
      getDateWeek: getDateWeek,
      getDateMonth: getDateMonth,
      netWorkDays: netWorkDays,
      convertTimezone: convertTimezone,
      formatDate: formatDate,
      getDateYear: getDateYear,
      left: left,
      right: right,
      mid: mid,
      length: length,
      replace: replace,
      regexReplace: regexReplace,
      extractRegex: extractRegex,
      lower: lower,
      upper: upper,
      trim: trim,
      trimLeft: trimLeft,
      trimRight: trimRight,
      capitalize: capitalize,
      random: random,
      getAddressStreet: getAddressStreet,
      getAddressStreet2: getAddressStreet2,
      getAddressCity: getAddressCity,
      getAddressState: getAddressState,
      getAddressCountry: getAddressCountry,
      getAddressZip: getAddressZip,
      getNameTitle: getNameTitle,
      getNameFirst: getNameFirst,
      getNameMiddle: getNameMiddle,
      getNameLast: getNameLast,
      getLinkURL: getLinkURL,
      getLinkLabel: getLinkLabel,
      max: max,
      min: min
    };
    var _removeObjects = function removeObjects(string) {
      if (!string || string.indexOf('{') === -1 || string.indexOf('}') === -1) {
        return string || '';
      }
      var objectStartIndex = string.indexOf('{');
      var objectEndIndex = 0;
      var level = 0;
      var found = false;
      _.each(string.split(''), function (stringChar) {
        if (found) {
          return;
        }
        objectEndIndex += 1;
        if (stringChar === '{') {
          level += 1;
        } else if (stringChar === '}') {
          level -= 1;
          if (!found && level === 0) {
            found = true;
          }
        }
      });
      var object = parseJSON(string.substring(objectStartIndex, objectEndIndex));
      var replacementValue = '';
      if (object.formatted_value || object.formatted_value === '') {
        replacementValue = string.substring(0, objectStartIndex) + object.formatted_value;
      } else {
        // if there is no object.formatted_value, then this is probably some JSON object that the user actually
        // meant to have in there, or there was some problem parsing it (not JSON maybe)
        replacementValue = string.substring(0, objectStartIndex) + string.substring(objectStartIndex, objectEndIndex);
      }
      return replacementValue + _removeObjects(string.substring(objectEndIndex, string.length));
    };
    var checkHasSupportedFunction = function checkHasSupportedFunction(string) {
      return _.find(supportedFunctions, function (supportedFunction) {
        return string.indexOf("".concat(supportedFunction, "(")) > -1;
      });
    };
    var checkHasSupportedFunctionPostEval = function checkHasSupportedFunctionPostEval(string) {
      return _.find(supportedFunctions, function (supportedFunction) {
        return string.indexOf("".concat(supportedFunction, "&#40;")) > -1;
      });
    };

    // to eval a set of functions, we need to eval the innermost function first, until there is nothing left to eval
    // we do that by calling this function recursively
    var _evalString = function evalString(string) {
      var foundSupportedFunction = checkHasSupportedFunction(string);

      // some unsupported thing was called, probably some user text in parens:
      if (!foundSupportedFunction) {
        return string;
      }

      // nothing to eval, no functions here:
      if (string.indexOf('(') === -1) {
        return "\"".concat(string, "\"");
      }

      // set function to eval
      var toEval = string.substring(0, string.indexOf('(') + 1);

      // need to find first set of closing parens at this level
      // for example: mid({field}, 1, length({field}) - 2)
      // we want:        ^  and                          ^
      // in:          left({field}, 1) right({field}, 1)
      // we want:         ^          ^
      var openParen = string.indexOf('(');
      var closeParen = 0;
      var level = 0;
      var found = false;
      _.each(string.split(''), function (stringChar) {
        if (stringChar === '(') {
          level += 1;
        } else if (stringChar === ')') {
          level -= 1;
          if (!found && level === 0) {
            found = true;
          }
        }
        if (!found) {
          closeParen += 1;
        }
      });

      // see if we need to evaluate anything inside of this string
      // get the inner params of the function:
      var params = string.substring(openParen + 1, closeParen);
      var afterText = string.substring(closeParen + 1, string.length);
      if (afterText.indexOf(')') === 0) {
        afterText = afterText.substring(1, afterText.length);
      }
      var continueParams = true;

      // function for ensuring that each internal parameter is evaluated
      var evalParams = function evalParams() {
        if (!params || !continueParams) {
          continueParams = false;
          return;
        }

        // check if the param does not need to be evaluated:
        // case 1: parameter index of , exists and is less than index of (, meaning the param is structured blah blah,
        //         (blah) (probably not a function call)
        // case 2: param has no ( and a , meaning that the param is likely blah blah blah, blah blah blah
        if (params.indexOf(',') !== -1 && params.indexOf(',') < params.indexOf('(') || params.indexOf('(') === -1 && params.indexOf(',') !== -1) {
          toEval += "\"".concat(params.substring(0, params.indexOf(',')), "\",");
          params = params.substring(params.indexOf(',') + 1, params.length);
          return;
        }

        // this is the case if we are done evaluating params for this function and there are still
        // iterations remaining, ensures that we stop iteration
        if (params.indexOf(')') === -1) {
          toEval += "\"".concat(params, "\"");
          continueParams = false;
          return;
        }

        // otherwise we have to evaluate the parameter:
        var toEvalString = params.substring(0, params.lastIndexOf(')') + 1);
        var innerEvalOutput = _evalString(toEvalString);
        if (outputString || checkHasSupportedFunctionPostEval(innerEvalOutput)) {
          innerEvalOutput = "\"".concat(innerEvalOutput, "\"");
        }
        toEval += innerEvalOutput + (params.lastIndexOf(',') > params.lastIndexOf(')') ? ',' : '');
        params = params.substring(params.lastIndexOf(')') + 1, params.length);

        // if we have params left, it might be something after a function call, for example:
        // `mid({field}, 1, length({field}) - 2)`, the - 2 might still remain to be added to toEval
        if (params && params.length) {
          // add all the way up to the next comma
          if (params.indexOf(',') > -1) {
            toEval += params.substring(0, params.indexOf(','));
            params = params.substring(params.indexOf(',') + 1, params.length);
          } else {
            // there are no more commas, we are done with this function after adding the params
            // add the rest of the params string, this is the last param
            toEval += params;
            params = '';
            continueParams = false;
          }
        } else {
          continueParams = false;
        }
      };
      while (continueParams) {
        evalParams();
      }
      toEval += ')';
      var runFunctionIndex = 0;
      var foundEvalSupportedFunction = false;
      _.each(supportedFunctions, function (supportedFunction) {
        var functionIndex = toEval.indexOf("".concat(supportedFunction, "("));
        if (!foundEvalSupportedFunction && functionIndex > -1) {
          runFunctionIndex = functionIndex;
          foundEvalSupportedFunction = true;
        }
      });
      var jsEvalInput = toEval.substring(runFunctionIndex, toEval.length);
      if (foundEvalSupportedFunction) {
        // eslint-disable-next-line no-eval
        jsEvalInput = eval(jsEvalInput).toString(); // DANGER!
      }
      var output = toEval.substring(0, runFunctionIndex) + jsEvalInput;

      // check for functions after the function we need to run. in this case, the structure could be something
      // like (1) + getDateYear(0), where we just evalled (1), and now need to run the getDateYear function
      var foundEvalSupportedFunctionInAfterText = false;
      _.each(supportedFunctions, function (supportedFunction) {
        var functionIndex = afterText.indexOf("".concat(supportedFunction, "("));
        if (!foundEvalSupportedFunctionInAfterText && functionIndex > -1) {
          foundEvalSupportedFunctionInAfterText = true;
        }
      });

      // if we have a supported function in the after_text, we can now eval it. otherwise, we're ready to move on
      if (foundEvalSupportedFunctionInAfterText) {
        output += _evalString(afterText);
      } else {
        output += afterText;
      }
      return output;
    };
    var equationOutput = _evalString(equation);
    equationOutput = decodeURIComponent(equationOutput);

    // at this point we still may have some JSON objects that were not consumed by string functions while evaluating
    // the equation. we need to iterate those and then replace each object with its formatted_value property.
    equationOutput = _removeObjects(equationOutput);
    equationOutput = deSanitizeString(equationOutput);
    equationOutput = _handleYearDateArithmetic(equationOutput);
    equationOutput = _stripYearObjects(equationOutput);
    equationOutput = stripNumericQuotes(equationOutput);

    // Trim equation output containing only whitespace as it causes problems further downstream
    if (whitespaceOnlyRegex.test(equationOutput)) {
      equationOutput = '';
    }
    delog("equation output: ".concat(equationOutput));
    return equationOutput;
  },
  evalNumericEquation: function evalNumericEquation(equation, timezone, isDateEquation) {
    delog("evalNumericEquation - input: ".concat(equation));

    // replace percentage sign prior to evalling as string equation as this can get interpreted as a mod
    // NOTE: this was in the code in Server that I moved over here, but I'm not sure what it does because
    // evalStringEquation() changes it back into a % symbol which is interpreted as mod operator (which
    // is what the above comment says this is supposed to prevent). I think it may prevent mod operator
    // in date math that might be handled by evalStringEquation(), so I'm leaving this here just to be
    // safe.
    equation = equation.replace(percentRegex, '&#37;');

    // this handles the calculations for date functions not supported by math.js, such as: dayOfWeek, dayOfMonth, etc
    equation = this.evalStringEquation(equation, false, false, timezone, isDateEquation);

    // check if we have a ternary that has an extra colon preceding its first expression.
    // Mathjs does not reject this in the current version, so we need to use a regex.
    // example: "<condition> ? : <some-expression>"
    if (invalidTernaryRegEx.test(equation)) {
      throw new InvalidEquationError();
    }

    // parse the equation into a tree, then traverse it to make sure we are not using any disallowed
    // syntaxes. see also: https://mathjs.org/docs/expressions/expression_trees.html#expression-trees
    var rootNode;
    try {
      rootNode = math.parse(equation);
    } catch (err) {
      delog("mathjs.parse() threw error: ".concat(err));
      throw new InvalidEquationError(err);
    }
    rootNode.traverse(function (node) {
      if (disallowedMathJsNodeTypes.has(node.type)) {
        delog("Used disallowed MathJS node type: ".concat(node.type));
        throw new InvalidEquationError();
      }
      if (node.type === 'FunctionNode') {
        var functionName = node.fn.name;
        if (disallowedMathJsFunctionNames.has(functionName)) {
          throw new InvalidEquationError("function \"".concat(functionName, "\" is not allowed"));
        }
      }
    });
    delog("Sending equation to mathjs: ".concat(equation));
    var result;
    try {
      var code = rootNode.compile();
      result = code.evaluate();
    } catch (err) {
      delog("mathjs.eval() threw error: ".concat(err));
      throw new InvalidEquationError(err);
    }
    if (debugging) {
      delog("Result from mathjs: ".concat(JSON.stringify(result)));
    }

    // some equations can result in a matrix, strip those to the first matrix value when setting the resultant value
    if (_typeof(result) === 'object' && result.entries && result.entries[0]) {
      result = result.entries[0]; // eslint-disable-line prefer-destructuring
    }
    if (typeof result !== 'number') {
      if (debugging) {
        delog("Result from mathjs was *NOT* a number: ".concat(JSON.stringify(result)));
      }
      result = 0;
    }

    // trim to 10 to get rid of the never-ending floating javascript problem
    if (result && String(result).length > 12) {
      result = parseFloat(Number(result).toFixed(10));
    }
    return result;
  },
  /**
   * @typedef FieldFormat
   * @type {Object}
   * @property {string} equation - The equation string (e.g., "abs(452 + {field_123})").
   * @property {'numeric'|'date'} equation_type - The type of equation ("numeric" or "date").
   * @property {'secons'|'hours'|'days'|'years'|'weeks'} date_type -
   *  When equation_type is "date", the unit of conversion.
   * @property {'number'|'date'} date_result -
   *  "number" to return a numeric timestamp or "date" to return a formatted date.
   * @property {'M D, yyyy'|'Ignore Date'|'mm/dd/yyyy'|'dd/mm/yyyy'} date_format - The desired date format.
   * @property {'HH:MM am'|'HH MM (military)'|'Ignore Time'} time_format - The desired time format.
   * @property {'period'|'comma'|'none'} mark_decimal - Specifies the decimal marker.
   * @property {'comma'|'space'|'period'|'none'} mark_thousands - Specifies the thousands delimiter.
   * @property {string} pre - An optional prefix to prepend to the formatted result.
   * @property {string} post - An optional postfix to append to the formatted result.
   * @property {string} precision - The number of decimal places to display.
   * @property {string} rounding - The rounding method ("up", "down", or "none").
   * @property {''|'$'|'£'|'€_after'|'€'|'%'|'custom'} format - The overall output format.
   */
  /**
   * @typedef EquationField
   * @type {Object}
   * @property {string} key - The equation field key.
   * @property {string} id - The equation field ID.
   * @property {FieldFormat} format - The equation format object.
   */
  /**
   * Evaluates an equation defined in an equation field, performing variable substitution,
   * calculation, and formatting according to the provided options.
   *
   * @param {EquationField} equationField - The equation field object.
   * @param {Object} vals - A mapping of field keys (e.g., "field_123") to string values for variable substitution.
   * @param {string} type - The evaluation type, typically "numeric" or "date".
   * @param {string=} appTimeFormatted - Optional timezone identifier (e.g., "America/New_York").
   *
   * @returns {string|number}
   */
  calculateEquation: function calculateEquation(equationField, vals, type, appTimeFormatted) {
    delog('calculateEquation');
    var equation = equationField.format.equation;
    if (!equationField.key) {
      // This is bad form, might need to remove this.
      equationField.key = equationField.id;
    }
    if (!equation) {
      equation = '';
    }
    var calc = '';
    var val;
    if (typeof equation === 'string') {
      calc = equation;
      for (var _i = 0, _Object$keys = Object.keys(vals); _i < _Object$keys.length; _i++) {
        var field = _Object$keys[_i];
        var fieldModel = equationField;
        var fieldValue = vals[field];
        if (!fieldValue) {
          val = 0;
        } else if (Array.isArray(fieldValue)) {
          // Don't try to replace symbols in the equation.
          // Currently the only symbol is FIELD_DEFAULT_REPLACE_WITH_FIRST which will be
          // replaced using hasFieldKey or hasConnectionFieldKey below.
          val = fieldValue.filter(function (fieldVal) {
            return _typeof(fieldVal) !== 'symbol';
          }).join(',');
        } else if (fieldValue) {
          val = fieldModel ? utils.stripNumber(fieldModel, fieldValue) : 0;
        }
        if (fieldModel && fieldModel.type === 'boolean') {
          var fieldFormat = fieldModel.format.format || fieldModel.format;
          switch (fieldFormat) {
            case 'true_false':
              val = fieldValue === 'True' ? 1 : 0;
              break;
            case 'on_off':
              val = fieldValue === 'On' ? 1 : 0;
              break;
            default:
              val = fieldValue === 'Yes' ? 1 : 0;
              break;
          }
        } else {
          val = Number(String(val).replace(/[^0-9.-]+/g, '')).toFixed(4);
        }
        calc = calc.replace(new RegExp("{".concat(field.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), "}"), 'g'), val);
      }
      calc = calc.replace(/currentTime\(\)/g, new Date().valueOf());
      calc = calc.replace(/currentDate\(\)/g, new Date().setUTCHours(0, 0, 0, 0).valueOf());
      var hasConnectionFieldKey = /{field_\d+.field_\d+}/g;
      var hasFieldKey = /{field_\d+}/g;

      // replace unmatched fields:
      calc = calc.replace(hasConnectionFieldKey, 0);
      calc = calc.replace(hasFieldKey, 0);
    } else {
      // legacy equations
      var _iterator2 = _createForOfIteratorHelper(equation),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          if (item.type === 'text') {
            if (item.text) {
              calc += item.text;
            }
          } else if (item.field && item.field.key) {
            var _field = this.getField(item.field.key);
            if (_field) {
              var fieldVal = vals[item.field.key] || 0;
              fieldVal = utils.stripNumber(_field, fieldVal);
              fieldVal = Number(String(fieldVal).replace(/[^0-9.-]+/g, '')).toFixed(4);
              calc += fieldVal;
            } else {
              calc += 0;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    try {
      if (['equation', 'numeric'].includes(type)) {
        val = this.evalNumericEquation(calc, appTimeFormatted, equationField.format.equation_type === 'date');
        var format = equationField.format;
        var precision = format.precision || '0';
        var result = Number(val).toFixed(Number(precision));
        val = formatHelper.formatNumber(result, format);
      } else {
        calc = this.evalStringEquation(calc, true, false, appTimeFormatted);
        val = eval(calc); // eslint-disable-line
      }
    } catch (err) {
      delog(err);
      val = 0;
    }
    if (equationField.format.equation_type === 'date' && equationField.format.date_result === 'date') {
      var formattedNumber = Number(formatHelper.formatNumber(val, equationField.format.date_format) * 1000);
      if (equationField.format.date_type !== 'years') {
        formattedNumber = this.convertDateVal(formattedNumber, equationField.format.date_type);
      } else {
        formattedNumber = formattedNumber * 365.25 * 24 * 60 * 60;
      }
      var dateFormat = '';
      if (equationField.format.date_format !== 'Ignore Date') {
        dateFormat += equationField.format.date_format.toUpperCase();
      }
      if (equationField.format.time_format !== 'Ignore Time') {
        dateFormat += " ".concat(equationField.format.time_format === 'HH:MM am' ? 'h:m a' : 'H:m');
      }
      formattedNumber = moment.tz(new Date(Number(formattedNumber)), appTimeFormatted);
      var offset = formattedNumber._offset;
      formattedNumber.subtract(offset, 'minutes');
      formattedNumber = formattedNumber.format(dateFormat);
      return formattedNumber;
    }
    return val;
  }
};
module.exports = commonEquationHelper;